<template>
  <base-show :fields="[fields]" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>

    <template slot="conditions" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['user_type'] !== null">
          会員属性：{{optionName('common/user_types', input['user_type'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['sex'] !== null">
          性別：{{optionName('common/genders', input['sex'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['birth_date'] !== null">
          生年月日：{{input['birth_date']}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['large_location'] !== null">
          店舗所在地(大)：{{optionName('common/large_locations', input['large_location'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['medium_location'] !== null">
          店舗所在地(中)：{{optionName('common/medium_locations', input['medium_location'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['biz_large_category'] !== null">
          店舗業態(大)：{{optionName('common/biz_large_categories', input['biz_large_category'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['biz_medium_category'] !== null">
          店舗業態(中)：{{optionName('common/biz_medium_categories', input['biz_medium_category'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['business_scale'] !== null">
          店舗規模(店舗数)：{{optionName('common/business_scales', input['business_scale'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['business_area'] !== null">
          主要店舗展開エリア：{{optionName('common/business_areas', input['business_area'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['lunch_menu'] !== null">
          ランチ営業有無：{{optionName('common/lunch_menus', input['lunch_menu'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['plan_num'] !== null">
          会員状態：{{optionName('common/plan_nums', input['plan_num'])}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['logged_in_at'] !== null">
          最終ログイン日時：{{input['logged_in_at']}}
        </CListGroupItem>
        <CListGroupItem style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap" v-if="input['user_ids'] !== null">
          ユーザID：{{input['user_ids']}}
        </CListGroupItem>
      </CListGroup>
    </template>
  </base-show>
</template>

<script>
  export default {
    props: {
      pk: {
        type: String,
        required: true
      }
    },
    data() {
      const vm = this;
      return {
        resourceName: "reminders",
        fields:
          [
            {
              label: "お知らせ公開(予定)日時",
              name: "publish_at",
              long: true
            },
            {
              label: "配信ユーザー指定(絞込)",
              name: "conditions",
              type: "custom",
              long: true
            },
            {
              label: "アンケートor商品レビュー",
              name: "notification_type",
              long: true,
              render: (v) => {
                return v === 2 ? 'アンケート' : '商品レビュー';
              }
            },
            {
              label: "お知らせタイトル",
              name: "title",
              long: true
            },
            {
              label: "お知らせ本文",
              name: "body",
              long: true,
            }
          ]
      };
    },
    computed: {
      entity() {
        return this.$store.getters[`${this.resourceName}/entity/entity`];
      },
      loading() {
        return this.$store.getters[`${this.resourceName}/entity/isLoading`];
      },
      breadcrumbs() {
        return [
          {
            text: "アンケートと商品レビュー催促管理",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "アンケートと商品レビュー催促詳細",
            disabled: true
          }
        ];
      },
      authAccountId() {
        return this.$store.getters[`auth/accountId`];
      },
      optionName() {
        return (optionName, value) => {
          const options =
            this.$store.getters[`${optionName}/options/options`] || [];
          return (options.find(v => v.value === value) || {}).label;
        };
      },
      dynamicFields() {
        if (this.entity.notification_type) {
          return this.addFields(this.entity.notification_type);
        }
        return [];
      }
    },
    methods: {
      addFields(type) {
        return type === 2 ?
          [
            {
              label: "アンケートID",
              name: "questionnaire_id"
            },
            {
              label: "アンケートURL",
              name: "url"
            },
            {
              label: "担当者",
              name: "name",
              long : true
            },
            {
              label: "回答人数/送信人数",
              name: "performed"
            },
            {
              label: "達成状態",
              name: "performed_status"
            }
          ] : [
            {
              label: "商品ID",
              name: "product_id"
            },
            {
              label: "商品レビューID",
              name: "review_set_id",
            },
            {
              label: "担当者",
              name: "name",
              long : true
            },
            {
              label: "回答人数/送信人数",
              name: "performed"
            },
            {
              label: "達成状態",
              name: "performed_status"
            }
          ]
      }
    },
    watch: {
      "entity.conditions.large_location": {
        handler(value) {
          if (value !== null) {
            this.$store.dispatch(
              `common/medium_locations/options/index`,
              value
            );
          }
        }
      },
      "entity.conditions.biz_large_category": {
        handler(value) {
          if (value !== null) {
            this.$store.dispatch(
              `common/biz_medium_categories/options/index`,
              value
            );
          }
        }
      },
      dynamicFields(value) {
        if (value && value.length) {
          this.fields = [...this.fields, ...value];
        }
      }
    },
    created(){
      this.$store.dispatch(`common/user_types/options/index`);
      this.$store.dispatch(`common/genders/options/index`);
      this.$store.dispatch(`common/large_locations/options/index`);
      this.$store.dispatch(`common/biz_large_categories/options/index`);
      this.$store.dispatch(`common/business_scales/options/index`);
      this.$store.dispatch(`common/business_areas/options/index`);
      this.$store.dispatch(`common/lunch_menus/options/index`);
      this.$store.dispatch(`common/plan_nums/options/index`);
    }
  };
</script>
